<template>
  <v-dialog persistent v-model="showDialog" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="showDialog = false; $emit('close')">$sl-close</v-icon>
      <h2>{{$t('application.delete-workplace')}}</h2>
      <v-card-text class="pl-0 pr-0">{{$t('application.delete-subtitle')}}</v-card-text>
      <v-card-actions class="d-flex justify-end">
        <ActionButton
          :block="false"
          actionIcon="$sl-cancel"
          @click="showDialog = false; $emit('close')"
        >{{ $t('labels.cancel') }}</ActionButton>
        <ActionButton
          class="ml-9"
          :block="false"
          type="application"
          actionIcon="$sl-delete"
          @click="deleteWorkplace"
        >{{ $t('labels.delete') }}</ActionButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
// @group Company
// ApprenticeListDraft component
export default {
  name: 'DeleteWorkplaceModal',
  props: {
    // Should dialog be showed
    show: false
    // fetch employee type
  },

  data: () => ({
    showDialog: false
  }),

  components: {
    ActionButton
  },

  watch: {
    /**
     * @vuese
     * Used to watch show prop and open modal
     */
    show(val) {
      this.showDialog = val
    }
  },

  methods: {
    /**
     * @vuese
     * Used to delete Workplace
     * @arg the arguments are integers representing company and workplace id
     */
    deleteWorkplace() {
      API.deleteWorkplace(this.$route.params.id, this.$route.params.workplace_id)
        .then(response => {
          this.$nextTick(() => {
            this.$router.push({name: 'CompanyWorkplaces', params: {id: this.$route.params.id}})
          })
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.delete-failure'))
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss">
.buttons {
  display: flex;
  justify-content: flex-end;
  button {
    text-transform: capitalize;
  }
  .v-btn__content {
    text-transform: uppercase;
  }
}
</style>